import BaseInput from './components/Inputs/BaseInput.vue'
import BaseCheckbox from './components/Inputs/BaseCheckbox.vue'
import BaseRadio from './components/Inputs/BaseRadio.vue'
import BaseDropdown from './components/BaseDropdown.vue'
import Card from './components/Cards/Card.vue'
import Datepicker from 'vue3-datepicker'
import ValidatedInput from './components/common/ValidatedInput.vue'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (app) {
    app.component(BaseInput.name, BaseInput)
    app.component(BaseCheckbox.name, BaseCheckbox)
    app.component(BaseRadio.name, BaseRadio)
    app.component(BaseDropdown.name, BaseDropdown)
    app.component('card', Card)
    app.component('date-picker', Datepicker)
    app.component('validated-input', ValidatedInput)
  }
}

export default GlobalComponents
